import {Routes } from '@angular/router';

import { LoginComponent } from './components/login.component';
import { LogoutComponent } from "./components/logout.component";

export const AUTH_ROUTES: Routes = [
    { path: 'login', component: LoginComponent },   
    { path: 'logout', component: LogoutComponent }
];
